
export default function CTASection() {
  return (
    <section className="py-16 bg-gradient-to-r from-[#C9002E] to-[#E60033] relative overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10">
        {/* 限定感ブロック */}
        <div className="bg-[#FFD700] text-[#C9002E] px-6 py-3 rounded-full inline-block mb-6 font-bold text-sm animate-pulse">
          <i className="ri-vip-crown-line mr-2"></i>
          29歳以下限定！最大21,000ポイント進呈
        </div>

        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            今すぐdカード GOLD Uに申し込む
          </h2>
          
          {/* キャンペーン情報 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6 border-2 border-white/30">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-gift-line text-4xl text-[#FFD700]"></i>
              <div className="text-left">
                <p className="text-white/90 text-sm">新規入会&利用特典</p>
                <p className="text-3xl font-bold text-white">最大21,000ポイント</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典①</p>
                <p className="text-white">29歳以下<br />年会費実質無料</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典②</p>
                <p className="text-white">ドコモ料金<br />5%還元</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典③</p>
                <p className="text-white">ポイ活MAX<br />最大11%還元</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4">
            <a
              href="https://dcard.docomo.ne.jp/dsw/application?kind=newgold"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white px-10 py-5 rounded-full font-bold text-lg transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line text-xl"></i>
              公式サイトで申し込む（PR）
            </a>
            <a
              href="https://dcard.docomo.ne.jp/dsw/change_rank?kind=newgold"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-white text-[#C9002E] px-10 py-5 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-up-circle-line text-xl"></i>
              dカードからアップグレード
            </a>
          </div>

          {/* 安心ポイント */}
          <div className="flex flex-wrap justify-center gap-4 text-white/90 text-sm mb-4">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>29歳以下限定</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>年会費実質無料</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>ゴールド特典満載</span>
            </div>
          </div>

          <p className="text-white/70 text-xs">
            ※29歳以下の方は条件達成で年会費3,300円がキャッシュバック
          </p>
        </div>
      </div>
    </section>
  );
}
